import { useEffect } from 'react'
import Button from './Button'
import { ui } from '../../styles/ui'

export default function ConfirmDialog({
  open,
  title = 'Please confirm',
  message = 'Are you sure?',
  onConfirm,
  onCancel,
  onClose,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  confirmVariant = 'danger',
  loading = false,
  children,
}) {
  const handleCancel = onCancel || onClose || (() => {})

  useEffect(() => {
    if (!open) return

    const handleKeyDown = (event) => {
      if (event.key === 'Escape' || event.key === 'Esc') {
        event.preventDefault()
        handleCancel()
      }
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => {
      window.removeEventListener('keydown', handleKeyDown)
    }
  }, [open, handleCancel])

  if (!open) {
    return null
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4" role="presentation">
      <div
        className={`${ui.cards.default} w-full max-w-md p-6`}
        role="dialog"
        aria-modal="true"
        aria-labelledby="confirm-dialog-title"
        aria-describedby="confirm-dialog-message"
      >
        <h2 id="confirm-dialog-title" className="text-xl font-semibold text-foreground">
          {title}
        </h2>
        <p id="confirm-dialog-message" className="mt-2 text-muted-foreground">
          {message}
        </p>
        {children}

        <div className={ui.forms.actions}>
          <div className="ml-auto flex items-center gap-2">
            <Button
              type="button"
              variant="secondary"
              onClick={(event) => {
                event.preventDefault()
                handleCancel()
              }}
              disabled={loading}
            >
              {cancelText}
            </Button>
            <Button
              type="button"
              variant={confirmVariant}
              onClick={(event) => {
                event.preventDefault()
                onConfirm?.()
              }}
              disabled={loading}
            >
              {loading ? 'Processing...' : confirmText}
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

